<template>
    <div class="container">
        <g-select
            showSearch
            placeholder="+1 (United States)"
            optionFilterProp="children"
            v-model="countryCode"
            :filterOption="filterOption"
            @change="handleSelect"
            class="country-code"
        >
            <template v-for="country in dedupedCountries">
                <g-select-option :value="country.code">{{ `+${country.phone_code} (${country.name})` }}</g-select-option>
            </template>
        </g-select>
        <div class="phone-number">
            <g-input
                v-model="phone"
                :disabled="isDisabled"
                placeholder="(000) 000-0000"
                @keyup="formatNumber"
            />
        </div>
    </div>
</template>

<script>
    import * as _ from 'lodash';
    import { parseNumber, AsYouType } from 'libphonenumber-js';

    export default {
        name: "PhoneNumberInput",
        props: {
            countries: {
                type: Array,
                default() {
                    return [];
                },
            },
            value: {
                type: Object
            },
        },
        data() {
            return {
                countryCode: undefined,
                phone: undefined,
            };
        },
        computed: {
            dedupedCountries() {
                return _.uniqBy(this.countries, 'code');
            },
            isDisabled() {
                return !this.value.countryCode && !this.countryCode;
            },
            isPhoneEntered() {
                return !!this.phone;
            },
            isCountryCodeSelected() {
                return !!this.countryCode;
            },
            isUS() {
                return this.countryCode.toUpperCase() === 'US';
            },
        },
        methods: {
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
            formatNumber() {
                if (this.isCountryCodeSelected && this.isPhoneEntered && this.isUS && this.phone.length > 5) {
                    this.phone = new AsYouType(this.countryCode).input(this.phone);
                }

                this.handle();
            },
            handleSelect(value) {
                this.countryCode = value;
                this.phone = '';
                this.handle();
            },
            handle: _.debounce(function () {
                if (this.isUS) {
                    this.$emit('phone-input', parseNumber(this.phone, this.countryCode));
                } else {
                    this.$emit('phone-input', {
                        country: this.countryCode,
                        phone: this.isPhoneEntered ? this.phone.replace(/[^0-9]/g, '') : undefined,
                    });
                }
            }, 300),
        },
        created() {
            this.countryCode = this.value.countryCode;
            this.phone = this.isUS
                ? new AsYouType(this.countryCode).input(this.value.number || '')
                : this.value.number || '';
        }
    }
</script>

<style lang="scss" scoped>
    .container {
        display: flex;
        & .country-code {
            width: 160px;
        }
        .phone-number {
            flex: 1;
        }
    }
</style>
